export default __webpack_public_path__ + "static/media/download.66d08a1b.svg";